<div class="flex justify-center w-full pb-8">
  @if (fileMimetype && fileSource) {
    <div
      class="relative flex justify-center w-28 h-28"
      [ngClass]="{ 'animate-rotate-bounce': isBackgroundThumbnailAnimatedSig() }"
    >
      <nrc-media-preview
        class="w-full h-full flex justify-center rounded-10 overflow-hidden shadow-inner bg-[#fefefe1a]"
        [mimetype]="fileMimetype"
        [source]="fileSource"
        [thumbnailSource]="fileThumbnail"
        [mediaPreviewTypes]="['image', 'video-snippet']"
      />
    </div>
  }

  <form class="flex flex-col justify-between py-1 pl-5 grow" [formGroup]="fileTitleForm">
    <div class="w-full">
      @if (fileTitleForm) {
        <nrc-input-text
          class="w-full"
          [formControl]="fileTitleForm.controls['title']"
          [type]="'text'"
          [name]="'file-replace-title'"
          [id]="'file-replace-title'"
          [label]="'COMPONENTS.FILE_REPLACER.INPUTS.TITLE.LABEL' | translate"
          [classList]="['bg-white/25']"
          [readonly]="true"
        />
      }

      <div class="w-full">
        <span class="text-xs font-light text-white/50">
          {{ fileDescription }}
        </span>
      </div>
    </div>

    <nrc-note
      class="w-full"
      [message]="{
        message: 'COMPONENTS.FILE_REPLACER.NOTE.MESSAGE.MESSAGE' | translate,
        level: level.WARN
      }"
    />
  </form>
</div>

<!-- File replacement section -->
@if (isReplacementComplete) {
  <!-- Replacement Complete State -->
  <div class="flex flex-col items-center justify-center w-full p-8 space-y-4 rounded-lg bg-cyan-500/10 border border-cyan-500/30">
    <div class="flex items-center justify-center w-16 h-16 rounded-full bg-cyan-500/20">
      <svg class="w-8 h-8 text-cyan-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
      </svg>
    </div>

    <div class="flex flex-col items-center space-y-2 text-center">
      <h3 class="text-md font-medium text-white">
        {{ 'COMPONENTS.FILE_REPLACER.REPLACEMENT_COMPLETE.TITLE' | translate }}
      </h3>
    </div>

    <nrc-button
      [label]="'COMPONENTS.FILE_REPLACER.REPLACEMENT_COMPLETE.UPLOAD_NEW_VERSION' | translate"
      [buttonType]="buttonType.DEFAULT"
      [role]="actionRole.TRANSPARENT_PRIMARY"
      (clickEvent)="uploadNewVersionEvent.emit()"
    />
  </div>
} @else if (isPdfGenerating) {
  <!-- PDF Generation Loading State -->
  <div class="flex flex-col items-center justify-center w-full p-8 space-y-4 rounded-lg bg-white/5 border border-white/10">
    <div class="relative">
      <nrc-loading-spinner class="w-12 h-12" />
    </div>

    <div class="flex flex-col items-center space-y-2 text-center">
      <h3 class="text-lg font-medium text-white">
        {{ 'COMPONENTS.FILE_REPLACER.PDF_GENERATION.TITLE' | translate }}
      </h3>
      <p class="text-sm text-white/70 max-w-md">
        {{ 'COMPONENTS.FILE_REPLACER.PDF_GENERATION.DESCRIPTION' | translate }}
      </p>
    </div>

    <div class="flex items-center gap-2 px-4 py-2 rounded-full bg-white/5">
      <div class="w-2 h-2 bg-blue-400 rounded-full animate-pulse"></div>
      <span class="text-xs font-medium text-white/80">
        {{ 'COMPONENTS.FILE_REPLACER.PDF_GENERATION.STATUS' | translate }}
      </span>
    </div>
  </div>
} @else {
  <!-- File Uploader -->
  <nrc-file-uploader
    [acceptableMimeTypes]="acceptableMimeTypes"
    [isMultipleUploadEnabled]="false"
    (filesChangedEvent)="handleFileSelected($event)"
    (fileSizeLimitExceededEvent)="fileSizeLimitExceededEvent.emit($event)"
  />
}
